import { useRef, MutableRefObject } from 'react'
import { useLocalStorage } from 'hooks/useLocalStorage'

const LS_SCHEDULING_NOTIFICATION_CLOSED_TOASTR =
  '__sales-engagement__surprise-scheduling-notification-closed-toastr'

type Callback = (key: string, value: string) => void

interface Map {
  [key: string]: string
}

function usePersistCloseToastr(): [Map, MutableRefObject<Callback>] {
  const [closedToastr, setClosedToastr] = useLocalStorage(
    LS_SCHEDULING_NOTIFICATION_CLOSED_TOASTR,
    {},
  )

  const setClosedToastrByKeyValue = (key: string, value: string): void => {
    setClosedToastr((oldClosedToastr: Map) => ({
      ...oldClosedToastr,
      [key]: value,
    }))
  }

  const indexFn = useRef(setClosedToastrByKeyValue)

  indexFn.current = setClosedToastrByKeyValue

  return [closedToastr, indexFn]
}

export { usePersistCloseToastr }
